import { render, staticRenderFns } from "./FinishedPar.vue?vue&type=template&id=21f2de81&scoped=true&"
import script from "./FinishedPar.vue?vue&type=script&lang=js&"
export * from "./FinishedPar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f2de81",
  null
  
)

export default component.exports